/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  PaginatedProtectedGroupDatasetList,
  PaginatedProtectedGroupList,
  PaginatedQuestionnaireAnswerList,
  PatchedQuestionnaireAnswerCreate,
  ProtectedGroup,
  ProtectedGroupDataset,
  QuestionnaireAnswer,
  QuestionnaireAnswerCreate,
} from '../models/index';
import {
  PaginatedProtectedGroupDatasetListFromJSON,
  PaginatedProtectedGroupDatasetListToJSON,
  PaginatedProtectedGroupListFromJSON,
  PaginatedProtectedGroupListToJSON,
  PaginatedQuestionnaireAnswerListFromJSON,
  PaginatedQuestionnaireAnswerListToJSON,
  PatchedQuestionnaireAnswerCreateFromJSON,
  PatchedQuestionnaireAnswerCreateToJSON,
  ProtectedGroupFromJSON,
  ProtectedGroupToJSON,
  ProtectedGroupDatasetFromJSON,
  ProtectedGroupDatasetToJSON,
  QuestionnaireAnswerFromJSON,
  QuestionnaireAnswerToJSON,
  QuestionnaireAnswerCreateFromJSON,
  QuestionnaireAnswerCreateToJSON,
} from '../models/index';

export interface ApiProtectedGroupDatasetsCreateRequest {
  datasetPath: Blob;
  protectedGroups: Array<number>;
}

export interface ApiProtectedGroupDatasetsListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiProtectedGroupDatasetsRetrieveRequest {
  id: number;
}

export interface ApiProtectedGroupsCreateRequest {
  protectedGroup: Omit<ProtectedGroup, 'id'>;
}

export interface ApiProtectedGroupsListRequest {
  page?: number;
}

export interface ApiProtectedGroupsRetrieveRequest {
  id: number;
}

export interface ApiQuestionnaireAnswersCreateRequest {
  questionnaireAnswerCreate: QuestionnaireAnswerCreate;
}

export interface ApiQuestionnaireAnswersDestroyRequest {
  id: number;
}

export interface ApiQuestionnaireAnswersListRequest {
  aiModel?: number;
  aiModelNameIcontains?: string;
  datasetPipeline?: number;
  page?: number;
}

export interface ApiQuestionnaireAnswersPartialUpdateRequest {
  id: number;
  patchedQuestionnaireAnswerCreate?: PatchedQuestionnaireAnswerCreate;
}

export interface ApiQuestionnaireAnswersRetrieveRequest {
  id: number;
}

export interface ApiQuestionnaireAnswersUpdateRequest {
  id: number;
  questionnaireAnswerCreate: QuestionnaireAnswerCreate;
}

/**
 *
 */
export class QuestionnaireApi extends runtime.BaseAPI {
  /**
   */
  async apiProtectedGroupDatasetsCreateRaw(
    requestParameters: ApiProtectedGroupDatasetsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProtectedGroupDataset>> {
    if (requestParameters['datasetPath'] == null) {
      throw new runtime.RequiredError(
        'datasetPath',
        'Required parameter "datasetPath" was null or undefined when calling apiProtectedGroupDatasetsCreate().',
      );
    }

    if (requestParameters['protectedGroups'] == null) {
      throw new runtime.RequiredError(
        'protectedGroups',
        'Required parameter "protectedGroups" was null or undefined when calling apiProtectedGroupDatasetsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['datasetPath'] != null) {
      formParams.append('dataset_path', requestParameters['datasetPath'] as any);
    }

    if (requestParameters['protectedGroups'] != null) {
      requestParameters['protectedGroups'].forEach(element => {
        formParams.append('protected_groups', element as any);
      });
    }

    const response = await this.request(
      {
        path: `/api/protected-group-datasets/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ProtectedGroupDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiProtectedGroupDatasetsCreate(
    requestParameters: ApiProtectedGroupDatasetsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProtectedGroupDataset> {
    const response = await this.apiProtectedGroupDatasetsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiProtectedGroupDatasetsListRaw(
    requestParameters: ApiProtectedGroupDatasetsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedProtectedGroupDatasetList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/protected-group-datasets/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedProtectedGroupDatasetListFromJSON(jsonValue));
  }

  /**
   */
  async apiProtectedGroupDatasetsList(
    requestParameters: ApiProtectedGroupDatasetsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedProtectedGroupDatasetList> {
    const response = await this.apiProtectedGroupDatasetsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiProtectedGroupDatasetsRetrieveRaw(
    requestParameters: ApiProtectedGroupDatasetsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProtectedGroupDataset>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiProtectedGroupDatasetsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/protected-group-datasets/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ProtectedGroupDatasetFromJSON(jsonValue));
  }

  /**
   */
  async apiProtectedGroupDatasetsRetrieve(
    requestParameters: ApiProtectedGroupDatasetsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProtectedGroupDataset> {
    const response = await this.apiProtectedGroupDatasetsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsCreateRaw(
    requestParameters: ApiProtectedGroupsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProtectedGroup>> {
    if (requestParameters['protectedGroup'] == null) {
      throw new runtime.RequiredError(
        'protectedGroup',
        'Required parameter "protectedGroup" was null or undefined when calling apiProtectedGroupsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/protected-groups/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ProtectedGroupToJSON(requestParameters['protectedGroup']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ProtectedGroupFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsCreate(
    requestParameters: ApiProtectedGroupsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProtectedGroup> {
    const response = await this.apiProtectedGroupsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsListRaw(
    requestParameters: ApiProtectedGroupsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedProtectedGroupList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/protected-groups/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedProtectedGroupListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsList(
    requestParameters: ApiProtectedGroupsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedProtectedGroupList> {
    const response = await this.apiProtectedGroupsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsRetrieveRaw(
    requestParameters: ApiProtectedGroupsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProtectedGroup>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiProtectedGroupsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/protected-groups/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ProtectedGroupFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows protected groups to be viewed or edited (internal).
   */
  async apiProtectedGroupsRetrieve(
    requestParameters: ApiProtectedGroupsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProtectedGroup> {
    const response = await this.apiProtectedGroupsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersCreateRaw(
    requestParameters: ApiQuestionnaireAnswersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuestionnaireAnswer>> {
    if (requestParameters['questionnaireAnswerCreate'] == null) {
      throw new runtime.RequiredError(
        'questionnaireAnswerCreate',
        'Required parameter "questionnaireAnswerCreate" was null or undefined when calling apiQuestionnaireAnswersCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: QuestionnaireAnswerCreateToJSON(requestParameters['questionnaireAnswerCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => QuestionnaireAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersCreate(
    requestParameters: ApiQuestionnaireAnswersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuestionnaireAnswer> {
    const response = await this.apiQuestionnaireAnswersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersDestroyRaw(
    requestParameters: ApiQuestionnaireAnswersDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiQuestionnaireAnswersDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersDestroy(
    requestParameters: ApiQuestionnaireAnswersDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiQuestionnaireAnswersDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersListRaw(
    requestParameters: ApiQuestionnaireAnswersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedQuestionnaireAnswerList>> {
    const queryParameters: any = {};

    if (requestParameters['aiModel'] != null) {
      queryParameters['ai_model'] = requestParameters['aiModel'];
    }

    if (requestParameters['aiModelNameIcontains'] != null) {
      queryParameters['ai_model__name__icontains'] = requestParameters['aiModelNameIcontains'];
    }

    if (requestParameters['datasetPipeline'] != null) {
      queryParameters['dataset_pipeline'] = requestParameters['datasetPipeline'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedQuestionnaireAnswerListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersList(
    requestParameters: ApiQuestionnaireAnswersListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedQuestionnaireAnswerList> {
    const response = await this.apiQuestionnaireAnswersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersPartialUpdateRaw(
    requestParameters: ApiQuestionnaireAnswersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuestionnaireAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiQuestionnaireAnswersPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedQuestionnaireAnswerCreateToJSON(requestParameters['patchedQuestionnaireAnswerCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => QuestionnaireAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersPartialUpdate(
    requestParameters: ApiQuestionnaireAnswersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuestionnaireAnswer> {
    const response = await this.apiQuestionnaireAnswersPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersRetrieveRaw(
    requestParameters: ApiQuestionnaireAnswersRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuestionnaireAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiQuestionnaireAnswersRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => QuestionnaireAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersRetrieve(
    requestParameters: ApiQuestionnaireAnswersRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuestionnaireAnswer> {
    const response = await this.apiQuestionnaireAnswersRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersUpdateRaw(
    requestParameters: ApiQuestionnaireAnswersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<QuestionnaireAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiQuestionnaireAnswersUpdate().',
      );
    }

    if (requestParameters['questionnaireAnswerCreate'] == null) {
      throw new runtime.RequiredError(
        'questionnaireAnswerCreate',
        'Required parameter "questionnaireAnswerCreate" was null or undefined when calling apiQuestionnaireAnswersUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questionnaire-answers/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: QuestionnaireAnswerCreateToJSON(requestParameters['questionnaireAnswerCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => QuestionnaireAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire answers to be viewed or edited. This is used for risk frequency estimation.
   */
  async apiQuestionnaireAnswersUpdate(
    requestParameters: ApiQuestionnaireAnswersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<QuestionnaireAnswer> {
    const response = await this.apiQuestionnaireAnswersUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
